import React from 'react';

import { useLatestRef } from './useLatestRef';

/**
 * Encapsulate setTimeout in a hook to provide a declarative api and
 * work with React's render model.
 *
 * Why? See explanation of some of the issues with setInterval in React,
 * these issues are often less obvious with setTimeout but still apply:
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
export function useTimeout(callback: () => void, delay: number) {
    const savedCallback = useLatestRef(callback);
    React.useEffect(() => {
        const tick = () => savedCallback.current();
        const id = window.setTimeout(tick, delay);
        return () => window.clearTimeout(id);
    }, [delay]);
}
